import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ITypedIds } from '../../../ts/ServerApi/types/ITypedIds';

export interface IGetActionableObjectsParams {
  // The action parameter is not yet implemented on the backend.
  // Currently the backend assumes we are asking if the user has the capability 'change_permissions'
  //
  // action: string;
  authorizables: ITypedIds;
}

export interface IGetActionableObjectsResult extends IResult {
  ids: string[];
}

export class GetActionableObjectsRequest extends Request<IGetActionableObjectsParams, IGetActionableObjectsResult> {
  constructor(params: IGetActionableObjectsParams) {
    super('getActionableObjects', params);
  }
}
